import React from "react";
import PropTypes from "prop-types";
import styles from "./SelectIBOHeader.module.css";
import { useTranslation } from "react-i18next";

export function SelectIBOHeader({ onSelectAll, onDone }) {
  const {t} = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.leftColumn}>
        <span className={styles.selectAll} onClick={onSelectAll}>{t("Select All")}</span>
      </div>
      <div className={styles.centerColumn}>
        <span className={styles.action}>{t("Action")}</span>
      </div>
      <div className={styles.rightColumn}>
        <span className={styles.done} onClick={onDone}>{t("Done")}</span>
      </div>
    </div>
  );
}

SelectIBOHeader.propTypes = {
  onSelectAll: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
};
